export default __webpack_public_path__ + "static/media/om-varshith.b4c35d06.jpg";